import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buttons-group',
  templateUrl: './buttons-group.component.html',
  styleUrls: ['./buttons-group.component.scss']
})
export class ButtonsGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
